import { AnyAction } from "redux";
import { SET_EDIT_USER_ROLES_LOADED } from "../actions/loadingEditUserRoles";

export const loadingEditUserRoles = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_EDIT_USER_ROLES_LOADED:
      return action.editUserRolesLoaded;
    default:
      return state;
  }
};

export default loadingEditUserRoles;
